var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfirmEmail = function SvgConfirmEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m48.71 18.43-3.54 3.6-.46.48-12.82 13.06-16.91-7.63-.53-.24-4.05-2.1 3.51-3.7 8.38-8.81 4.75-5 6.37 3.04 2.3 1.1 7.85 3.75.6.29 4.55 2.16Z",
    fill: "#28BF9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m42.24 11.18 1.96 11.33h.51L31.89 35.57 15.19 28 12.9 17.03l29.34-5.85Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10.407 25.593-.01.002 4.452 25.25 38.378-6.767-4.453-25.25-.55.096-3.054 3.106-.46.48-12.82 13.06-16.91-7.63-.53-.24-4.05-2.1.007-.007Z",
    fill: "#C2E2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m51.68 41.23-18.22 3.21-18.31 2.19 15.81-16.32 20.72 10.92Z",
    fill: "#C2E2FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m27.77 34.318-12.26 12.66-.72-.696 12.26-12.66.72.696ZM51.447 41.672l-16.22-8.55.466-.884 16.22 8.55-.466.884Z",
    fill: "#192C55"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "confirmEmail_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 4,
    width: 53,
    height: 52
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.85 5.29c2.83.15 5.25 1.07 7.01 2.82 6.41 6.41 1.63 21.57-10.67 33.86-12.3 12.3-27.46 17.07-33.86 10.67-3.32-3.32-3.64-9-1.45-15.42",
    stroke: "#192C55",
    strokeMiterlimit: 10
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#confirmEmail_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#confirmEmail_svg__b)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 43,
    rx: 27,
    ry: 20,
    transform: "rotate(-30.521 45 43)",
    fill: "#116DFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#confirmEmail_svg__c)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 16,
    r: 16,
    fill: "#5FF2AE"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#confirmEmail_svg__d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 53,
    r: 18,
    fill: "#0021FF"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.992 19.36A6.496 6.496 0 0 1 28.64 16l-.96.132a6.567 6.567 0 0 1-1.32 3.876A6.429 6.429 0 0 1 23 22.36l.132.96a6.567 6.567 0 0 1 3.876 1.32A6.429 6.429 0 0 1 29.36 28l.96-.132a6.567 6.567 0 0 1 1.32-3.876A6.429 6.429 0 0 1 35 21.64l-.132-.96a6.567 6.567 0 0 1-3.876-1.32ZM13.563 9.437A4.43 4.43 0 0 1 12.325 7h-.65a4.399 4.399 0 0 1-1.238 2.437A4.399 4.399 0 0 1 8 10.675v.65a4.4 4.4 0 0 1 2.437 1.238A4.4 4.4 0 0 1 11.675 15h.65a4.4 4.4 0 0 1 1.238-2.437A4.4 4.4 0 0 1 16 11.325v-.65a4.4 4.4 0 0 1-2.437-1.238Z",
    fill: "#116DFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "confirmEmail_svg__b",
    x: 17.613,
    y: 18.98,
    width: 54.773,
    height: 48.041,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4951_3068"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "confirmEmail_svg__c",
    x: 29,
    y: -6,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_4951_3068"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "confirmEmail_svg__d",
    x: -2,
    y: 33,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4951_3068"
  })))));
};
export default SvgConfirmEmail;